<h2 mat-dialog-title>{{ 'AI_ASSISTANT.SETTINGS.ENABLE_LEAD_CAPTURE.DESCRIPTION' | translate }}</h2>
<mat-dialog-content>
  <p class="subtitle">{{ 'AI_ASSISTANT.SETTINGS.ENABLE_LEAD_CAPTURE_DIALOG.INFORMATION_HEADING' | translate }}</p>
  <span class="learn-content">{{ 'AI_ASSISTANT.SETTINGS.ENABLE_LEAD_CAPTURE_DIALOG.INFORMATION' | translate }}</span>
  <p class="subtitle">{{ 'AI_ASSISTANT.SETTINGS.ENABLE_LEAD_CAPTURE_DIALOG.INFORMATION_2_HEADING' | translate }}</p>
  <span class="learn-content">{{ 'AI_ASSISTANT.SETTINGS.ENABLE_LEAD_CAPTURE_DIALOG.INFORMATION_2' | translate }}</span>
  <p class="subtitle">{{ 'AI_ASSISTANT.SETTINGS.ENABLE_LEAD_CAPTURE_DIALOG.INFORMATION_3_HEADING' | translate }}</p>
  <span class="learn-content">{{ informationKey() | translate }}</span>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button color="primary" mat-dialog-close>{{ 'AI_ASSISTANT.SHARED.CLOSE' | translate }}</button>
</mat-dialog-actions>
